/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
export default function createPaintSystem(
  state, 
  ui     
) {
  function updateCanPaint(canId, paintUsed) {
    const canIndex = state.cansData.findIndex(c => c.id === canId);
    if (canIndex !== -1) {
      const oldPaint = state.cansData[canIndex].paintLeft;
      state.cansData[canIndex].paintLeft = Math.max(0, oldPaint - paintUsed);
      if (ui && typeof ui.updatePaintUI === 'function') {
        ui.updatePaintUI(canId, oldPaint, state.cansData[canIndex].paintLeft);
      }
      if (typeof window.updatePaintLeft === 'function') {
        window.updatePaintLeft(canId, state.cansData[canIndex].paintLeft);
      }
    }
  }
  return { 
    updateCanPaint 
  };
}
